<style>
.edi-detail-bill .detail-bill-footer div.detail-bill-info p.total-p {
    margin: .5em 5px;
    font-size: 1em;
}
.edi-detail-bill .detail-scroll .bill-all-info-background{
	width: 100%;
}
.edi-detail-bill .detail-scroll .detail-bill-info-list-background {
	float: none;
}
.edi-detail-bill .detail-bill-list .detail-item-remark {
	display: inline-block;
	overflow-x: auto;
	width: 79%;
	vertical-align: middle;
	height: 20px;
}
</style>
<template>
	<div class="edi-detail-bill">
		<!-- <div class="filter">
			<input type="text" placeholder="" class="ui-search-input"/>
		</div> -->
		<navbar title="餐企询价单-明细"></navbar>
		<div v-show="scrollShow" class="common-scroll detail-scroll">
			<p class="detail-bill-status">询价单号：{{billDetailData.trans_bill_no}}
				<span class="nav-btn" @click="openBillInfo()">
					<img src="../assets/nav-btn.png" alt="">
				</span>
				<span v-if="billDetailData.bill_state == 40" class="state-grey-font">未确认</span>
				<span v-if="billDetailData.bill_state == 41" class="state-aqua-font">已同意</span>
				<span v-if="billDetailData.bill_state == 42" class="state-red-font">已确认</span>
				<span v-if="billDetailData.bill_state == 49" class="state-grey-font">已退回</span>
			</p>
			<div class="bill-all-info bill-all-info-background" v-show="billInfoShow">
				<ul class="detail-bill-info-list detail-bill-info-list-background">
					<li class="detail-bill-fulllist">询价企业：{{billDetailData.restaurant_name}}</li>
				</ul>
			</div>
			<div class="detail-bill-search-wrapper">
				<input class="detail-search-input" placeholder="请输入要搜索的品项名称" v-model="searchWord">
			</div>
			<div class="detail-bill-wrapper">
				<h4 class="detail-bill-address aqua-font">
					明细条目({{detailsFilter.length}})
					<span>
						<span style="font-size:13px; color:#333">已报价({{getPricedCount}})</span>
						<span style="font-size:13px; color:#333">未报价({{getUnPricedCount}})</span>
					</span>
					<router-link v-if="billDetailData.bill_state == 41" :to="{ path: '/detail-inquiry-price-edit', query: { bill_id: queryData.bill_id , searchWord: searchWord}}" class="detail-bill-edit state-aqua-font" replace>编辑</router-link>
				</h4>
				<ul class="detail-bill-list width-full">
					<li v-for="billDetail in detailsFilter" :key="billDetail.goods_id" class="width-full">
						<ul class="detail-bill-sonlist width-full">
							<li class="detail-bill-fulllist detail-bill-list-title">
								{{billDetail.goods_name}}({{billDetail.goods_unit}})
							</li>
							<li v-if="isPesc">规格：{{billDetail.goods_spec}}</li>
							<li>税率：{{billDetail.goods_cess}} %</li>
							<li>含税单价：{{billDetail.goods_price_send | numFixed(numScale)}} 元</li>
							<li>备注：<div class="detail-item-remark">{{billDetail.remark || ''}}</div></li>
              <li v-show="isZ5 && inquiryAmountFlag">询价数量：{{billDetail.goods_num_sended | numFixed(4)}}</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
		<div v-show="scrollShow" class="detail-bill-footer">
			<div class="detail-bill-info" style="float: right">
				<div v-if="billDetailData.bill_state == 40" class="detail-bill-return f-right">
					<a @click="agreen(41)">同意</a>
				</div>
				<div v-if="billDetailData.bill_state == 40 || billDetailData.bill_state == 41" class="detail-bill-red f-right">
					<a @click="refuseB">退回</a>
				</div>
				<div v-if="billDetailData.bill_state == 41" class="detail-bill-return f-right">
					<a @click="billConfirm">确认</a>
				</div>
				<div v-if="billDetailData.bill_state != 40 && billDetailData.bill_state != 49" class="detail-bill-return f-right" style="border-right: solid 1px #fff">
					<a @click="importExcel">Excel</a>
				</div>
			</div>
		</div>
		<loading v-show="loading"></loading>
		<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
		<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
		<tips v-show="tipsB" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatusB"></tips>
		<tips-t hasTipsFont :btnFont="btnFont" :tipsFont="tipsFont" ref="tipsTShow" v-on:tipStatus = "getStatues"></tips-t>
	</div>
</template>

<script>
import Loading from '../components/loading'
import Tips from '../components/Tips'
import TipsT from '../components/TipsT'
import TipsAuto from '../components/TipsAuto'
import NavBar from '../components/NavBar'
export default {
	data () {
		return {
			scrollShow: false,
			tips: false,
			tipsB: false,
			btnNum: 2,
			loading: true,
			tipsauto: false,
			tipsFont: '',
			numScale: 2,
			sec: 1500,
			goodsTotalInfo: {},
			accountInfo: {},
			email: '',
			btnFont: ['确定', '取消'],
			billDetailData: {},
			billDetails: [],
			searchWord: '',
			queryData: this.$route.query,
			show: false,
			billInfoShow: false,
			isPesc: false,
			isZ5: false,
			inquiryAmountFlag: false
		}
	},
	components: {
		'loading': Loading,
		'tips-auto': TipsAuto,
		'tips': Tips,
		'tips-t': TipsT,
		'navbar': NavBar
	},
	beforeRouteLeave (to, from, next) {
		if (to.path === '/detail-inquiry-price-edit' && this.billDetailData.bill_state === 42) {
			this.$router.go(-1)
		} else {
			next()
		}
	},
	created () {
		this.loading = true
		var filterData = {
			bill_id: this.queryData.bill_id
		}
		this.getEmail()
		this.$http.post('/cldEdi/business/billWithDetail', filterData).then((response) => {
			const forceUploadPermitFlag = (!response.body.otherdata || response.body.otherdata.forceUploadPermitFlag === null) ? false : response.body.otherdata.forceUploadPermitFlag
			this.isZ5 = response.body.otherdata == null ? false : response.body.otherdata.isZ5
			this.inquiryAmountFlag = response.body.otherdata == null ? false : response.body.otherdata.inquiryAmountFlag

			if (!this.isZ5 && forceUploadPermitFlag === true) {
				this.$fxToast.warning('请上传供货商证照信息！')
				this.$router.replace({path: '/main/my'})
			}

			this.loading = false
			this.scrollShow = true
			this.billDetailData = response.body.data
			this.numScale = (this.billDetailData.number_scale || this.billDetailData.number_scale === 0) ? this.billDetailData.number_scale : 2
			this.billDetails = response.body.data.details
			this.isPesc = this.billDetailData.isPesc // 是否显示规格的系统参数
		}, (response) => {
			this.loading = false
			this.autoTips('服务请求失败，稍后请重试！')
		})
	},
	methods: {
		getEmail () {
			// 获取邮箱信息
			this.$http.get('/cldEdi/business/getCurrentLoginUser').then((response) => {
				this.accountInfo = response.body.data
				this.email = this.accountInfo.email
			})
		},
		getStatues (msg) {
			switch (msg) {
			case 'bindEmail':
				this.$router.push('/email-bind')
				this.goodsTotalInfo.emailLinksChange = true
				break
			case 'sendEmail':
				this.sendEmail()
				break
			}
		},
		sendEmail () {
			// 对接导出excel并发送邮件接口
			this.loading = true
			var billId = {
				'bill_id': this.queryData.bill_id
			}
			this.$http.post('/cldEdi/business/8001', billId).then((response) => {
				this.loading = false
				var data = response.body
				if (data.result) {
					this.autoTips('邮件发送成功')
				} else {
					this.autoTips(data.message)
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		infoExchange () {
			this.show = !this.show
		},
		tipStatus (msg) {
			this.tips = false
			this.msg = msg
			if (this.state === 42 && this.msg[1] === true) {
				this.agreen(42)
				return false
			} else if (this.state === 49 && this.msg[1] === true) {
				this.refuseBack()
				return
			}
		},
		tipStatusB (msg) {
			this.tipsB = false
			this.msg = msg
			if (this.msg[1] === true) {
				this.refuse()
				return false
			}
		},
		autoTips (msg, secp) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, secp || self.sec)
		},
		tipsTShow (str) {
			// 弹出操作提示框
			this.$refs.tipsTShow.open(str)
		},
		importExcel () {
			// 导出Excel
			// 1、判断邮箱是否绑定
			var val = this.email
			if (val === null) {
				// 未绑定邮箱，提示绑定邮箱
				this.tipsFont = '用户尚未绑定邮箱'
				this.btnFont = ['去绑定', '取消']
				this.tipsTShow('bindEmail')
			} else {
				// 已绑定邮箱，提示将excel发送至绑定邮箱
				this.tipsFont = '将单据导出Excel并发送至绑定邮箱'
				this.btnFont = ['确定', '取消']
				this.tipsTShow('sendEmail')
			}
		},
		agreen (state) {
			this.loading = true
			var updateData = {
				bill_state: state,
				id: this.billDetailData.id
			}
			this.$http.post('/cldEdi/business/bill/updateBillState', updateData).then((response) => {
				this.loading = false
				var data = response.body
				if (data.result) {
					if (data && data.data && data.data.billState === 'checked') {
						this.billDetailData.bill_state = state
						this.autoTips('餐企已将采购询价单审核，询价单修改的信息将不会同步到询价单上，自动将单据状态置为已完成；且不会将在供货商EDI中修改的信息同步至供应链的询价单中。', 3000)
					} else {
						this.billDetailData.bill_state = state
						let operMsg = '同意'
						switch (state) {
						case 41:
							operMsg = '询价单已同意'
							break
						case 42:
							operMsg = '询价单已确认'
							break
						}
						this.autoTips(operMsg)
					}
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		refuse () {
			this.tips = true
			this.state = 49
			this.tipsFont = '确认退回询价单？'
		},
		refuseB () {
			this.tipsB = true
			this.tipsFont = '询价单退回后将不可撤销，是否继续？'
		},
		refuseBack () {
			this.loading = true
			var updateData = {
				bill_state: 49,
				id: this.billDetailData.id
			}
			this.$http.post('/cldEdi/business/bill/updateBillState', updateData).then((response) => {
				this.loading = false
				var self = this
				var data = response.body
				if (data.result) {
					this.billDetailData.bill_state = 49
					this.autoTips('询价单已退回')
					setTimeout(function () {
						self.$router.go(-1)
					}, 1500)
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		billConfirm () {
			this.state = 42
			this.tips = true
			this.btnNum = 2
			this.tipsFont = '是否确认？'
		},
		openBillInfo () {
			this.billInfoShow = !this.billInfoShow
		}
	},
	filters: {
		// edi小数位数处理
		numFixed (val, scale) {
			// if (scale) {
			// 	return val ? val.toFixed(scale) : ''
			// } else {
			return val
			// }
		}
	},
	computed: {
		sumSubTotalSend () {
			let sumSubTotalSend = 0
			if (this.billDetails) {
				for (let i = 0; i < this.billDetails.length; i++) {
					sumSubTotalSend += this.billDetails[i].sub_total_send
				}
			}
			return sumSubTotalSend
		},
		detailsFilter () {
			if (this.searchWord.trim()) {
				return this.billDetails.filter(detail => detail.goods_name.indexOf(this.searchWord.trim()) >= 0)
			} else {
				return this.billDetails
			}
		},
		getPricedCount () {
			let cnt = 0
			if (this.billDetails && this.billDetails.length) {
				this.billDetails.forEach(function (item) {
					console.log(item)
					if (item.goods_price_send > 0) {
						cnt++
					}
				})
			}
			return cnt
		},
		getUnPricedCount () {
			let cnt = 0
			if (this.billDetails && this.billDetails.length) {
				this.billDetails.forEach(function (item) {
					console.log(item)
					if (!item.goods_price_send > 0) {
						cnt++
					}
				})
			}
			return cnt
		}
	}
}
</script>



// WEBPACK FOOTER //
// InquiryPriceDetailBill.vue?c7b81026